// @ts-nocheck — TODO: tipizzare quando si tocca (markOwnMutation/globalThis.api da dichiarare)
// ====== state-api.js — operazioni di scrittura Supabase ======
// Era dentro state.js (480+ righe). Estratto qui per ridurre i "dio moduli".
// Espone globalThis.api con tutti i metodi CRUD del dominio.

const api = {
  // ---- Risorse ----
  async addResource(nome) {
    const { data, error } = await sb.from('risorse').insert({ nome }).select('id, nome').single();
    if (error) throw error;
    return data;
  },
  async deleteResource(nome) {
    const id = _resourceIdByName.get(nome);
    if (!id) throw new Error('Risorsa non trovata: ' + nome);
    const { error } = await sb.from('risorse').delete().eq('id', id);
    if (error) throw error;
  },

  // ---- Clienti ----
  // Salva (insert o update) un cliente completo con tutte le sotto-collezioni
  async saveClient(client, originalName) {
    let cliId = originalName ? _clientIdByName.get(originalName) : null;
    const payload = {
      nome: client.nome,
      cpl: client.cpl || '',
      pm1: client.pm1 || '',
      pm2: client.pm2 || '',
      tecnici: client.tecnici || [],
      service_line_ref: client.serviceLineRef || '',
      ruolo: client.ruolo || '',
      assegnazione_perenne: client.assegnazionePerenne || '',
      directory: client.directory || '',
      pim: client.pim || '',
      perimetri: client.perimetri || [],
      note: client.note || '',
      tenant_id: client.tenantId || ''
    };

    if (cliId) {
      const { error } = await sb.from('clienti').update(payload).eq('id', cliId);
      if (error) throw error;
    } else {
      const { data, error } = await sb.from('clienti').insert(payload).select('id').single();
      if (error) throw error;
      cliId = data.id;
    }

    // Sync accessi: delete-all + reinsert (semplice e affidabile per il volume attuale)
    await sb.from('accessi').delete().eq('cliente_id', cliId);
    const accessiRows = Object.entries(client.accessi || {})
      .filter(([_, stato]) => stato)
      .map(([resName, stato]) => {
        const risorsaId = _resourceIdByName.get(resName);
        return risorsaId ? { cliente_id: cliId, risorsa_id: risorsaId, stato } : null;
      })
      .filter(Boolean);
    if (accessiRows.length) {
      const { error } = await sb.from('accessi').insert(accessiRows);
      if (error) throw error;
    }

    // Contratto: upsert (1:1, distinguo via cliente_id come chiave logica)
    await sb.from('contratti').delete().eq('cliente_id', cliId);
    const ct = client.contratto || {};
    const hasContratto =
      ct.numero || ct.tipo || ct.inizio || ct.fine || ct.ore || ct.importo || ct.note;
    if (hasContratto) {
      const ctPayload = {
        cliente_id: cliId,
        numero: ct.numero || '',
        tipo: ct.tipo || '',
        inizio: ct.inizio || null,
        fine: ct.fine || null,
        ore: ct.ore !== '' && ct.ore != null ? parseInt(ct.ore, 10) || null : null,
        importo: ct.importo || '',
        note: ct.note || ''
      };
      const { error } = await sb.from('contratti').insert(ctPayload);
      if (error) throw error;
    }

    // Referenti / Documenti / Scadenze: stessa strategia (replace)
    await sb.from('referenti').delete().eq('cliente_id', cliId);
    if (client.referenti?.length) {
      const rows = client.referenti.map((r) => ({
        cliente_id: cliId,
        nome: r.nome || '',
        ruolo: r.ruolo || '',
        email: r.email || '',
        telefono: r.telefono || '',
        note: r.note || ''
      }));
      const { error } = await sb.from('referenti').insert(rows);
      if (error) throw error;
    }

    await sb.from('documenti').delete().eq('cliente_id', cliId);
    if (client.documenti?.length) {
      const rows = client.documenti.map((d) => ({
        cliente_id: cliId,
        titolo: d.titolo || '',
        tipo: d.tipo || '',
        url: d.url || '',
        note: d.note || ''
      }));
      const { error } = await sb.from('documenti').insert(rows);
      if (error) throw error;
    }

    await sb.from('scadenze').delete().eq('cliente_id', cliId);
    if (client.scadenze?.length) {
      const rows = client.scadenze.map((s) => ({
        cliente_id: cliId,
        titolo: s.titolo || '',
        tipo: s.tipo || '',
        data: s.data || null,
        note: s.note || '',
        completata: !!s.completata
      }));
      const { error } = await sb.from('scadenze').insert(rows);
      if (error) throw error;
    }

    // Realtime: marca la mutation come "nostra" cosi' l'echo non triggera un refresh duplicato
    if (typeof markOwnMutation === 'function') markOwnMutation(cliId, 2000);
    return cliId;
  },

  // Soft-delete: marca deleted_at = now(). Il cliente non appare più nei
  // listing standard ma resta recuperabile dal cestino per 30 giorni.
  async deleteClient(nome) {
    const id = _clientIdByName.get(nome);
    if (typeof markOwnMutation === 'function' && id) markOwnMutation(id, 2000);
    if (!id) throw new Error('Cliente non trovato: ' + nome);
    const { error } = await sb
      .from('clienti')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id);
    if (error) throw error;
  },

  // Lista clienti nel cestino (soft-deleted)
  async listDeletedClients() {
    const { data, error } = await sb
      .from('clienti')
      .select('id, nome, cpl, deleted_at, perimetri')
      .not('deleted_at', 'is', null)
      .order('deleted_at', { ascending: false });
    if (error) throw error;
    return (data || []).map((c) => ({
      id: c.id,
      nome: c.nome,
      cpl: c.cpl || '',
      deletedAt: c.deleted_at,
      perimetri: Array.isArray(c.perimetri) ? c.perimetri : []
    }));
  },

  // Ripristino: rimette deleted_at = NULL
  async restoreClient(id) {
    const { error } = await sb.from('clienti').update({ deleted_at: null }).eq('id', id);
    if (error) throw error;
  },

  // Eliminazione definitiva (hard delete) dal cestino
  async hardDeleteClient(id) {
    const { error } = await sb.from('clienti').delete().eq('id', id);
    if (error) throw error;
  },

  // Admin-only: aggiorna lo stato di un singolo accesso (cliente x risorsa)
  async updateAccessStato(clienteName, risorsaName, stato) {
    const cliId = _clientIdByName.get(clienteName);
    const resId = _resourceIdByName.get(risorsaName);
    if (!cliId || !resId) throw new Error('Cliente o risorsa non trovati');
    if (typeof markOwnMutation === 'function') markOwnMutation(cliId);
    if (stato) {
      const { error } = await sb
        .from('accessi')
        .upsert(
          { cliente_id: cliId, risorsa_id: resId, stato },
          { onConflict: 'cliente_id,risorsa_id' }
        );
      if (error) throw error;
    } else {
      const { error } = await sb
        .from('accessi')
        .delete()
        .eq('cliente_id', cliId)
        .eq('risorsa_id', resId);
      if (error) throw error;
    }
  },

  // Aggiorna stato + ruoli + note di un accesso via RPC update_accesso (security definer)
  async updateAccesso(clienteName, risorsaName, { stato, ruoli, note }) {
    const cliId = _clientIdByName.get(clienteName);
    const resId = _resourceIdByName.get(risorsaName);
    if (!cliId || !resId) throw new Error('Cliente o risorsa non trovati');
    if (typeof markOwnMutation === 'function') markOwnMutation(cliId);
    const { error } = await sb.rpc('update_accesso', {
      p_cliente_id: cliId,
      p_risorsa_id: resId,
      p_stato: stato || '',
      p_ruoli: Array.isArray(ruoli) ? ruoli : [],
      p_note: note || ''
    });
    if (error) throw error;
  },

  // Aggiorna SOLO la riga di accesso dell'utente loggato (per il ruolo "utente")
  async updateOwnAccess(clienteName, risorsaName, stato) {
    const cliId = _clientIdByName.get(clienteName);
    const resId = _resourceIdByName.get(risorsaName);
    if (!cliId || !resId) throw new Error('Cliente o risorsa non trovati');
    if (typeof markOwnMutation === 'function') markOwnMutation(cliId);
    if (stato) {
      const { error } = await sb
        .from('accessi')
        .upsert(
          { cliente_id: cliId, risorsa_id: resId, stato },
          { onConflict: 'cliente_id,risorsa_id' }
        );
      if (error) throw error;
    } else {
      const { error } = await sb
        .from('accessi')
        .delete()
        .eq('cliente_id', cliId)
        .eq('risorsa_id', resId);
      if (error) throw error;
    }
  },

  // ---- Utenti portale ----
  async listUsers() {
    const { data, error } = await sb
      .from('utenti_portale')
      .select('id, user_id, email, name, role, active, risorsa_id, risorse(nome)')
      .order('name');
    if (error) throw error;
    return (data || []).map((u) => ({
      id: u.id,
      userId: u.user_id,
      email: u.email,
      name: u.name,
      role: u.role,
      active: u.active,
      resourceName: u.risorse?.nome || '',
      risorsaId: u.risorsa_id,
      linked: !!u.user_id
    }));
  },

  async upsertUser(u) {
    let risorsaId = null;
    if (u.resourceName) {
      risorsaId = _resourceIdByName.get(u.resourceName) || null;
    }
    const payload = {
      email: (u.email || '').trim().toLowerCase(),
      name: (u.name || '').trim(),
      role: u.role === 'admin' ? 'admin' : 'utente',
      risorsa_id: risorsaId,
      active: u.active !== false
    };
    if (u.id) {
      const { error } = await sb.from('utenti_portale').update(payload).eq('id', u.id);
      if (error) throw error;
      return u.id;
    }
    const { data, error } = await sb.from('utenti_portale').insert(payload).select('id').single();
    if (error) throw error;
    return data.id;
  },

  async toggleUserActive(id, active) {
    const { error } = await sb.from('utenti_portale').update({ active }).eq('id', id);
    if (error) throw error;
  },

  async deleteUser(id) {
    const { error } = await sb.from('utenti_portale').delete().eq('id', id);
    if (error) throw error;
  },

  // ---- Persone interne (rubrica CPL / PM / referenti Agic) ----
  async listPersone() {
    const { data, error } = await sb
      .from('persone_interne')
      .select('id, nome, email, ruolo, note, active')
      .order('nome');
    if (error) throw error;
    return (data || []).map((p) => ({
      id: p.id,
      nome: p.nome || '',
      email: p.email || '',
      ruolo: p.ruolo || '',
      note: p.note || '',
      active: p.active !== false
    }));
  },
  async upsertPersona(p) {
    const payload = {
      nome: (p.nome || '').trim(),
      email: (p.email || '').trim().toLowerCase() || null,
      ruolo: (p.ruolo || '').trim() || null,
      note: (p.note || '').trim() || null,
      active: p.active !== false
    };
    if (!payload.nome) throw new Error('Nome obbligatorio');
    if (p.id) {
      const { error } = await sb.from('persone_interne').update(payload).eq('id', p.id);
      if (error) throw error;
      return p.id;
    }
    const { data, error } = await sb.from('persone_interne').insert(payload).select('id').single();
    if (error) throw error;
    return data.id;
  },
  async deletePersona(id) {
    const { error } = await sb.from('persone_interne').delete().eq('id', id);
    if (error) throw error;
  },

  // ---- Audit log ----
  async insertAudit(entry) {
    const { error } = await sb.from('audit_log').insert(entry);
    if (error) console.error('audit insert error', error);
  },

  async clearAuditLog() {
    const { error } = await sb
      .from('audit_log')
      .delete()
      .neq('id', '00000000-0000-0000-0000-000000000000');
    if (error) throw error;
  }
};

globalThis.api = api;
export {};
